import { HTMLProps, ReactNode, useRef } from 'react';
import './card.scss';
import { Skeleton } from '../Skeleton/Skeleton';

const Divider = ({
  cardPadding = '0',
  space = '1.5rem',
}: {
  cardPadding?: string;
  space?: string;
}) => {
  const style = { marginLeft: '0', marginRight: '0', marginTop: '0', marginBottom: '0' };
  if (cardPadding !== '0') {
    style.marginLeft = `-${cardPadding}`;
    style.marginRight = `-${cardPadding}`;
  }
  if (space !== '0') {
    style.marginTop = space;
    style.marginBottom = space;
  }
  return <div className="border-bottom" style={style} />;
};

const SubCard = ({
  children,
  className,
  ...rest
}: { children: ReactNode; className?: string } & HTMLProps<HTMLDivElement>) => (
  <div className={`border border-1 w-100 rounded bg-white ${className}`} {...rest}>
    {children}
  </div>
);

const Info = ({
  label,
  isLoading = false,
  skeletonLines = 1,
  className = '',
  children,
}: {
  label: ReactNode;
  isLoading?: boolean;
  skeletonLines?: number;
  className?: string;
  children: ReactNode;
}) => {
  const labelRef = useRef<HTMLDivElement>(null);
  return (
    <div className={`card-info mb-1 ${className}`}>
      <small ref={labelRef}>{label}</small>
      {isLoading ? (
        <Skeleton skeletonLines={skeletonLines} />
      ) : (
        <div aria-label={labelRef.current?.textContent ?? ''}>{children}</div>
      )}
    </div>
  );
};

export const Card = ({
  children,
  className = '',
  ...rest
}: {
  children: ReactNode;
  className?: string;
} & HTMLProps<HTMLDivElement>) => (
  <div
    className={`card border w-100 rounded bg-white shadow overflow-visible ${className}`}
    {...rest}
  >
    {children}
  </div>
);

Card.Divider = Divider;
Card.SubCard = SubCard;
Card.Info = Info;
